import { dataBellSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBellSolid = /*#__PURE__*/createIcon(dataBellSolid)
export default IconBellSolid
